
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexKjCAR_yPw03OVcTuNWGw0zERoaNlsQyRzQcOquIX3lkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/index.vue?macro=true";
import { default as indexMdb99C1F77_n9h_45ThJhL2ixwhg3gQG_45g1rMOUocs7m8Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Login/index.vue?macro=true";
import { default as indexZte2FjVPvBPL_45r5g7uaZiSDrwYW1E0mnAGLTEvYleWoMeta } from "C:/temporary/iqa/iQA_FRONT/pages/portal/index.vue?macro=true";
import { default as indexpZrBfla3Ch768ZB_jXO7vS1fJlMG83joppyoKH8U8dEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/index.vue?macro=true";
import { default as indexP13p_45geT4_cvrpcJJ4gCF4U7tFvkSrx_45N9wLmHF9puEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Customers/index.vue?macro=true";
import { default as indexmBQgrST5Nw2ITGBjVeCwntKF_45Ji3zb8z5DlEkhCTGdAMeta } from "C:/temporary/iqa/iQA_FRONT/pages/selectTenant/index.vue?macro=true";
import { default as indexDw4qK6aQuTkgdgbkCSwL_45X3lECFDc7Ju5Dwe3L7ogYAMeta } from "C:/temporary/iqa/iQA_FRONT/pages/ResetPassword/index.vue?macro=true";
import { default as indexdjWIlDimtCcAGqbjGFWotXyw0wpZczEAEq0Ym0_D6s4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/charts/index.vue?macro=true";
import { default as indexaEQeXho_R4ijOYsmUMwmQzcyTBQxxynalmtU3fLaEYQMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/labels/index.vue?macro=true";
import { default as indexcJtUhRwX05_45zsGdSk8oED64_45A6f6iVXkIwkk9urODbkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/index.vue?macro=true";
import { default as indexsQGKg1BlS5psNtrjdKVWCv3IXGISWp_457DfaCTK8a4S4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/reporting/index.vue?macro=true";
import { default as indexwDXY_45pWlND_yB3eF6HdqjA02F_zKPl8IDe0bgVYuWgsMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/index.vue?macro=true";
import { default as index_459s5h7h1FMVjiQAG7nQBESG070j0dNuMufMuc_451CAicMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/index.vue?macro=true";
import { default as index8n98_45vax7SYStJpARLGszDTubQb3OU3DqEUr4gFl0AAMeta } from "C:/temporary/iqa/iQA_FRONT/pages/portal/certificates/index.vue?macro=true";
import { default as indexSy7_riIQqthOG3JbnTvcj7DJX043JE6z6NHndq1swLkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/certificates/index.vue?macro=true";
import { default as newHTL7eDJItiekgIGJvw0_t4_gq9uTW11oxdKHXmE_457_YMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/users/new.vue?macro=true";
import { default as tree2zk57rDuKFphtcTFbQl_45Oe8OGrP3NXXn_45g42O2AnV7oMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/menus/tree.vue?macro=true";
import { default as _91id_93_4515DdsKj3RhMsAXslBIuLMlsORcMw4IKLGtO0ODjwPEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/roles/[id].vue?macro=true";
import { default as _91id_93MCEc8lsL8Fi0P6K0LrdjOSuhaKX68yk2mEJOIKpzscIMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/users/[id].vue?macro=true";
import { default as index5wt_KI7tmSl8uEzuc3IFQNgvmg2XAlRD0vXKfl56jF0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/menus/index.vue?macro=true";
import { default as indexUkvJmujyT2gbOE5sfhuEsdX41tPboJ1KuSiRfqmLY2sMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/roles/index.vue?macro=true";
import { default as indexXgyJQnJh2zJJKtD8ACsdSu4JpD_45QHoG69ocZ8dXd39QMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/users/index.vue?macro=true";
import { default as indexXUcgPymH2T_QUhDYZkefC4dq9n1pUBLX6HsiO98xf4wMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/index.vue?macro=true";
import { default as indexvvz96oAejk1no2CX6syW0ACPHYANWPSH3v2KqOwvr54Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/tenants/index.vue?macro=true";
import { default as indexR_2_B_45PxABa6kNYhWnR6KnDGzqNV_45__45TJOjasgAAGtgMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/index.vue?macro=true";
import { default as indexWYgYw5ExpDyYkzP1MDHRK4DdNnwcPeY4QpKLPG9V290Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/shifts/index.vue?macro=true";
import { default as indexRyQARyWkEk0wSyzxatGRM7eAYaU7JbfuwCIhyRe91K8Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/defects/index.vue?macro=true";
import { default as _91id_93z2wolQi017wAw7jgdzjI2UzRTcWvYocE8sQlGMbuyWQMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/products/[id].vue?macro=true";
import { default as _91id_93upPcPj1AX3UnW3bWKS83vVLby_0V9iBjAxlEeUTJ0p0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/customers/[id].vue?macro=true";
import { default as indexVgN0MbdsgroaHTAYvxyeVddoWf_cherknGqN0nXD8WQMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/machines/index.vue?macro=true";
import { default as indexdhHuxgeSMl6xSuV7y3z6oMS0LM5HWVKycvt82lQ1IfwMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/products/index.vue?macro=true";
import { default as _91id_93_45l_45nVLGBtPy_3yqd73mOiznKN3wSbSXgYK_45Y_45ImzB_0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/certificates/form/new/[id].vue?macro=true";
import { default as indexjdf0uEjaDo1P_pD_rQ6Q230coHhbcjTure9zQRpg5P4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/customers/index.vue?macro=true";
import { default as indexfNLqp2dKPHqKsGseawOhJgW5HP7qKH4oJjga3OS9lxYMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/densities/index.vue?macro=true";
import { default as indexvU8xHUqkBdsnsxfHVhkFd1BBj1xDObcJppqkWZyArO4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/materials/index.vue?macro=true";
import { default as indexOeGamXUE6IvqFBqU0CxFLYuLaLNDd0rDqvyjQlPIhsQMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/processes/index.vue?macro=true";
import { default as indexaHIuJBueEomfAZpiw_9i6XygyaQZ5ah3TOSoCFIl6esMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/suppliers/index.vue?macro=true";
import { default as indexkhxJRivP3ZJQjVJA4XG1eTj5axyE4vH5TA0LjB9CRUMMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/permissions/index.vue?macro=true";
import { default as tablezn4Ujwh1PHlOPQlBg8I_45H6iYz1vpdYQvbfSvq_Ncuk8Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/security/permissions/table.vue?macro=true";
import { default as _91id_93TolDtvZNI3MKSz4glQE8XzsKLRzGtMB5f2_U_VurLEcMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/certificates/form/edit/[id].vue?macro=true";
import { default as indexlTAsDaABeo9OY_45rugEAw2XJ4V0dDWjOJopiwslV9YaMMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/operations/index.vue?macro=true";
import { default as indexRgMaMigsomYuU14jddNW76vURMx549OUAWYs4g3NQD4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/index.vue?macro=true";
import { default as _91id_936NzazzNjg4zmBSPnf98KSTXqpDrDCye1F2WMpV1IzmwMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/measurements/[id].vue?macro=true";
import { default as indexPbswkY8Bx46SsvtAT6pOh_45YXf8LZbe7_45bw92iLie0K0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/dispositions/index.vue?macro=true";
import { default as indexDpnLO97KoTsvbarpn3CRQdYuv_451k5sDEUPqQAWrSOEsMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/measurements/index.vue?macro=true";
import { default as indexduRguMZWGHnKm6OayFEHpdNOOMU3FFXpvo1XMeLjMekMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/workstations/index.vue?macro=true";
import { default as index9GA9T_45qu12Mldzf1O9f4_45JnOLxhTnTMZrbQPG5ylLSgMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/actions/index.vue?macro=true";
import { default as indexIN_45KjUkUjAU_45M6Nev1HMDNzWD3vH0z7a0RfdsQNSonwMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/index.vue?macro=true";
import { default as indexKvqguLsqO7mdr_p0lFLyV803iBfo9tczAVWjmMAQBsoMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/pause-reasons/index.vue?macro=true";
import { default as index_45P5VUG1NWYtItWgjZRHvJ26Xh620nTA_454GjT5XXzaCcMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/machines-types/index.vue?macro=true";
import { default as indexBdy6WBzOsiGEKGjJlBpXxDymhkXUqhgNoGjFzo_45UaRsMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-rex3/index.vue?macro=true";
import { default as index7U7siVPgkkCdK1irjp9IDNkwwD_epGwubDY6fU0_454KUMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/rex3-specs/index.vue?macro=true";
import { default as index79Yh_45y_4STFf9nZUZOSMTaxXDMaPyPaDVGazMdm0y_45YMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/non-conformities/index.vue?macro=true";
import { default as indexLsigav4_451g2UVo7a_OhDbdmr_hv_KXM__45nRJjeHAkBkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/units-of-measure/index.vue?macro=true";
import { default as indexheDVOfNSPpDcF_45VHpyCDY4QRfcRhBBn1Vfdd4I5TMWwMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/thicknesses/index.vue?macro=true";
import { default as tree_45backupgLmPcH1tAAHqiMSAxomIM1x8V6a45Z8FyytYig8cH6cMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/tree-backup.vue?macro=true";
import { default as index_wGePMh_45OOf8bFvQxJxZDNIvPfzPinHiToCgqiwyeooMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/processes-defects/index.vue?macro=true";
import { default as indexmMqupHPuTTwm8__buU5tjA3_NPS1jYAv_45doGtNhrcioMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-batches/index.vue?macro=true";
import { default as index1ZTkPILSQ3XLQPuyzyG0CO1pc51bii5Wy9vPsIZlNR4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/items-combinations/index.vue?macro=true";
import { default as indexpYAtQUufJB8N0_4537JNlCXAinQecnVOmYn0dzRiZiR74Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/forms-testing/index.vue?macro=true";
import { default as index_45dfSYXSxx8iT6KnTnC8BU1910ki_XqLUFquZ6nH7ZtEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/product-specs/index.vue?macro=true";
import { default as live_45resulti_452Ha24oWjnjGDbRXzQ7wMKWSydWCEHokXz1Ro0B334Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/live-result.vue?macro=true";
import { default as tree_45backup_45q_459cBEvNNEmt431u_wY8zHUPqZwKqvnfpA0QPSKvmkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/tree-backup.vue?macro=true";
import { default as _91orderId_93clrgui76EPIGbDQms7lWwWVXaRrOZUd7IJ8o4FPWCG0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/products/[orderId].vue?macro=true";
import { default as indexjomO56kwnA52gkPuewwU3rLPVwujHlv79G0As10MkXoMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/suppliers-materials/index.vue?macro=true";
import { default as indexPva2_oGCHuKKdfiIoWMVYcs0qvQaAxAhprB_k05N4i8Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/machine-limits/index.vue?macro=true";
import { default as indexp3eV3WK8b8ph6On7jSEkdtQJjSrTdPZe7v5GtCmy_uEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-open-cell/index.vue?macro=true";
import { default as indexsd0CokZqOr1_ftkYrCZUCs0sQHDXNNHb9DpLqXGAIC4Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/open-cell-specs/index.vue?macro=true";
import { default as indexqYbdt9zFZe7Y0GoKgLTmJkyiWQwe8yGN3WXgVPV2fjwMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/management/workstations-products/index.vue?macro=true";
import { default as indexqTaDkX7gEES1jrWVIW1NSChTAMMpSXUyUAWeaIH_QPEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-types/index.vue?macro=true";
import { default as indexNSVN9b0WOWS8W5NIZYy72qu_45EY9sE9QDFnKZkzyxi_45UMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/reporting/non-conforming-products/index.vue?macro=true";
import { default as indexQbmBfQp47aL9QD_hlGqU_45aYB_45IZjMzxC7qF6n3tGYjsMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-templates/index.vue?macro=true";
import { default as indexPNkJ0WJee2ntEUTJ9vDHN8TnBqJfuYyKd802_z5i3D0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/certificates-templates/index.vue?macro=true";
import { default as indextbMB4o3wIGe2LNuLiYxwmVixhVFwwGgoGAdRVzD_45KbkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/inspections/[orderId]/index.vue?macro=true";
import { default as _91id_93R8kMRaAnUsXA8S15ctbJzcVngFrFXc_45SAdgPng6S7aYMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-templates/form/[id].vue?macro=true";
import { default as _91inspectionId_93LetIuiQTsAyEF8WvFGfLcb5EQGyCPJWuSN8RYq10ZVQMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/form/edit/[inspectionId].vue?macro=true";
import { default as indexXrrxOMdUiacNGRgAA1s5te7Mecher8fL_45hTpe0Eo7rkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-templates/form/index.vue?macro=true";
import { default as indexg_MpsE_45U_hlvJcX_BfJebvL5wlqJGyC0lu933X8ZB7kMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/quality-inspections-sealx/index.vue?macro=true";
import { default as _91id_93J36WTq_45NJFJGbq2Z51tsl8u6QCiEvsoeflDEh3u51D0Meta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/certificates-templates/form/[id].vue?macro=true";
import { default as _91inspectionId_93S_45qK7OlkDIESChzKhiUm82pLvYH8jfbTPSs5tnqdNzYMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/form/edit/[inspectionId].vue?macro=true";
import { default as indexMHNLpvtAqJHOX6w_EVR_45afvd_N_Lp_nfSp_R6b8CW1oMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/certificates-templates/form/index.vue?macro=true";
import { default as _91inspectionId_937gs3vgDNjZH84bJJ6dwRjmOHy61aBlHVJ8_45BiLFZxikMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-rex3/form/edit/[inspectionId].vue?macro=true";
import { default as _91inspectionId_93ZppH_45WqSl2RJs3OJKHv5p3CQ6x_UhOXWYe84gQqPXPIMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-batches/form/edit/[inspectionId].vue?macro=true";
import { default as _91inspectionTemplateId_93cHNU7IJwqlxegdY__45440m_acuOETEeH_455orS5NtceKoMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/form/new/[inspectionTemplateId].vue?macro=true";
import { default as _91inspectionTemplateId_93thu_45cGmxZ6j9o_cU8C_p2_451pTRgudcrPI6L2ZKHOqpUMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/form/new/[inspectionTemplateId].vue?macro=true";
import { default as _91inspectionId_93yJnDCzcCWOh7xF2htk8O6O_TOFFO9fCtAv_45nr8kJXMEMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-open-cell/form/edit/[inspectionId].vue?macro=true";
import { default as _91inspectionId_93ndalD5SrN0vE5nkfD2iTidDkUJ7XPI98wYUr1vsISBkMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/inspections/[orderId]/form/edit/[inspectionId].vue?macro=true";
import { default as _91inspectionTemplateId_933r19q0ucVf47uc962oCe2pFm4MuRPPzP2wnyiI0p2xgMeta } from "C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/inspections/[orderId]/form/new/[inspectionTemplateId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexKjCAR_yPw03OVcTuNWGw0zERoaNlsQyRzQcOquIX3lkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: indexMdb99C1F77_n9h_45ThJhL2ixwhg3gQG_45g1rMOUocs7m8Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Login/index.vue")
  },
  {
    name: "portal",
    path: "/portal",
    meta: indexZte2FjVPvBPL_45r5g7uaZiSDrwYW1E0mnAGLTEvYleWoMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/portal/index.vue")
  },
  {
    name: "Modules",
    path: "/Modules",
    meta: indexpZrBfla3Ch768ZB_jXO7vS1fJlMG83joppyoKH8U8dEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/index.vue")
  },
  {
    name: "Customers",
    path: "/Customers",
    meta: indexP13p_45geT4_cvrpcJJ4gCF4U7tFvkSrx_45N9wLmHF9puEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Customers/index.vue")
  },
  {
    name: "selectTenant",
    path: "/selectTenant",
    meta: indexmBQgrST5Nw2ITGBjVeCwntKF_45Ji3zb8z5DlEkhCTGdAMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/selectTenant/index.vue")
  },
  {
    name: "ResetPassword",
    path: "/ResetPassword",
    meta: indexDw4qK6aQuTkgdgbkCSwL_45X3lECFDc7Ju5Dwe3L7ogYAMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/ResetPassword/index.vue")
  },
  {
    name: "Modules-charts",
    path: "/Modules/charts",
    meta: indexdjWIlDimtCcAGqbjGFWotXyw0wpZczEAEq0Ym0_D6s4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/charts/index.vue")
  },
  {
    name: "Modules-labels",
    path: "/Modules/labels",
    meta: indexaEQeXho_R4ijOYsmUMwmQzcyTBQxxynalmtU3fLaEYQMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/labels/index.vue")
  },
  {
    name: "Modules-security",
    path: "/Modules/security",
    meta: indexcJtUhRwX05_45zsGdSk8oED64_45A6f6iVXkIwkk9urODbkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/index.vue")
  },
  {
    name: "Modules-reporting",
    path: "/Modules/reporting",
    meta: indexsQGKg1BlS5psNtrjdKVWCv3IXGISWp_457DfaCTK8a4S4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/reporting/index.vue")
  },
  {
    name: "Modules-data-entry",
    path: "/Modules/data-entry",
    meta: indexwDXY_45pWlND_yB3eF6HdqjA02F_zKPl8IDe0bgVYuWgsMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/index.vue")
  },
  {
    name: "Modules-management",
    path: "/Modules/management",
    meta: index_459s5h7h1FMVjiQAG7nQBESG070j0dNuMufMuc_451CAicMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/index.vue")
  },
  {
    name: "portal-certificates",
    path: "/portal/certificates",
    meta: index8n98_45vax7SYStJpARLGszDTubQb3OU3DqEUr4gFl0AAMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/portal/certificates/index.vue")
  },
  {
    name: "Modules-certificates",
    path: "/Modules/certificates",
    meta: indexSy7_riIQqthOG3JbnTvcj7DJX043JE6z6NHndq1swLkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/certificates/index.vue")
  },
  {
    name: "Modules-security-users-new",
    path: "/Modules/security/users/new",
    meta: newHTL7eDJItiekgIGJvw0_t4_gq9uTW11oxdKHXmE_457_YMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/users/new.vue")
  },
  {
    name: "Modules-security-menus-tree",
    path: "/Modules/security/menus/tree",
    meta: tree2zk57rDuKFphtcTFbQl_45Oe8OGrP3NXXn_45g42O2AnV7oMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/menus/tree.vue")
  },
  {
    name: "Modules-security-roles-id",
    path: "/Modules/security/roles/:id()",
    meta: _91id_93_4515DdsKj3RhMsAXslBIuLMlsORcMw4IKLGtO0ODjwPEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/roles/[id].vue")
  },
  {
    name: "Modules-security-users-id",
    path: "/Modules/security/users/:id()",
    meta: _91id_93MCEc8lsL8Fi0P6K0LrdjOSuhaKX68yk2mEJOIKpzscIMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/users/[id].vue")
  },
  {
    name: "Modules-security-menus",
    path: "/Modules/security/menus",
    meta: index5wt_KI7tmSl8uEzuc3IFQNgvmg2XAlRD0vXKfl56jF0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/menus/index.vue")
  },
  {
    name: "Modules-security-roles",
    path: "/Modules/security/roles",
    meta: indexUkvJmujyT2gbOE5sfhuEsdX41tPboJ1KuSiRfqmLY2sMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/roles/index.vue")
  },
  {
    name: "Modules-security-users",
    path: "/Modules/security/users",
    meta: indexXgyJQnJh2zJJKtD8ACsdSu4JpD_45QHoG69ocZ8dXd39QMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/users/index.vue")
  },
  {
    name: "Modules-quality-control",
    path: "/Modules/quality-control",
    meta: indexXUcgPymH2T_QUhDYZkefC4dq9n1pUBLX6HsiO98xf4wMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/index.vue")
  },
  {
    name: "Modules-security-tenants",
    path: "/Modules/security/tenants",
    meta: indexvvz96oAejk1no2CX6syW0ACPHYANWPSH3v2KqOwvr54Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/tenants/index.vue")
  },
  {
    name: "Modules-data-entry-orders",
    path: "/Modules/data-entry/orders",
    meta: indexR_2_B_45PxABa6kNYhWnR6KnDGzqNV_45__45TJOjasgAAGtgMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/index.vue")
  },
  {
    name: "Modules-management-shifts",
    path: "/Modules/management/shifts",
    meta: indexWYgYw5ExpDyYkzP1MDHRK4DdNnwcPeY4QpKLPG9V290Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/shifts/index.vue")
  },
  {
    name: "Modules-management-defects",
    path: "/Modules/management/defects",
    meta: indexRyQARyWkEk0wSyzxatGRM7eAYaU7JbfuwCIhyRe91K8Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/defects/index.vue")
  },
  {
    name: "Modules-management-products-id",
    path: "/Modules/management/products/:id()",
    meta: _91id_93z2wolQi017wAw7jgdzjI2UzRTcWvYocE8sQlGMbuyWQMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/products/[id].vue")
  },
  {
    name: "Modules-management-customers-id",
    path: "/Modules/management/customers/:id()",
    meta: _91id_93upPcPj1AX3UnW3bWKS83vVLby_0V9iBjAxlEeUTJ0p0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/customers/[id].vue")
  },
  {
    name: "Modules-management-machines",
    path: "/Modules/management/machines",
    meta: indexVgN0MbdsgroaHTAYvxyeVddoWf_cherknGqN0nXD8WQMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/machines/index.vue")
  },
  {
    name: "Modules-management-products",
    path: "/Modules/management/products",
    meta: indexdhHuxgeSMl6xSuV7y3z6oMS0LM5HWVKycvt82lQ1IfwMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/products/index.vue")
  },
  {
    name: "Modules-certificates-form-new-id",
    path: "/Modules/certificates/form/new/:id()",
    meta: _91id_93_45l_45nVLGBtPy_3yqd73mOiznKN3wSbSXgYK_45Y_45ImzB_0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/certificates/form/new/[id].vue")
  },
  {
    name: "Modules-management-customers",
    path: "/Modules/management/customers",
    meta: indexjdf0uEjaDo1P_pD_rQ6Q230coHhbcjTure9zQRpg5P4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/customers/index.vue")
  },
  {
    name: "Modules-management-densities",
    path: "/Modules/management/densities",
    meta: indexfNLqp2dKPHqKsGseawOhJgW5HP7qKH4oJjga3OS9lxYMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/densities/index.vue")
  },
  {
    name: "Modules-management-materials",
    path: "/Modules/management/materials",
    meta: indexvU8xHUqkBdsnsxfHVhkFd1BBj1xDObcJppqkWZyArO4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/materials/index.vue")
  },
  {
    name: "Modules-management-processes",
    path: "/Modules/management/processes",
    meta: indexOeGamXUE6IvqFBqU0CxFLYuLaLNDd0rDqvyjQlPIhsQMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/processes/index.vue")
  },
  {
    name: "Modules-management-suppliers",
    path: "/Modules/management/suppliers",
    meta: indexaHIuJBueEomfAZpiw_9i6XygyaQZ5ah3TOSoCFIl6esMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/suppliers/index.vue")
  },
  {
    name: "Modules-security-permissions",
    path: "/Modules/security/permissions",
    meta: indexkhxJRivP3ZJQjVJA4XG1eTj5axyE4vH5TA0LjB9CRUMMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/permissions/index.vue")
  },
  {
    name: "Modules-security-permissions-table",
    path: "/Modules/security/permissions/table",
    meta: tablezn4Ujwh1PHlOPQlBg8I_45H6iYz1vpdYQvbfSvq_Ncuk8Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/security/permissions/table.vue")
  },
  {
    name: "Modules-certificates-form-edit-id",
    path: "/Modules/certificates/form/edit/:id()",
    meta: _91id_93TolDtvZNI3MKSz4glQE8XzsKLRzGtMB5f2_U_VurLEcMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/certificates/form/edit/[id].vue")
  },
  {
    name: "Modules-management-operations",
    path: "/Modules/management/operations",
    meta: indexlTAsDaABeo9OY_45rugEAw2XJ4V0dDWjOJopiwslV9YaMMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/operations/index.vue")
  },
  {
    name: "Modules-data-entry-inspections",
    path: "/Modules/data-entry/inspections",
    meta: indexRgMaMigsomYuU14jddNW76vURMx549OUAWYs4g3NQD4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/index.vue")
  },
  {
    name: "Modules-management-measurements-id",
    path: "/Modules/management/measurements/:id()",
    meta: _91id_936NzazzNjg4zmBSPnf98KSTXqpDrDCye1F2WMpV1IzmwMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/measurements/[id].vue")
  },
  {
    name: "Modules-management-dispositions",
    path: "/Modules/management/dispositions",
    meta: indexPbswkY8Bx46SsvtAT6pOh_45YXf8LZbe7_45bw92iLie0K0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/dispositions/index.vue")
  },
  {
    name: "Modules-management-measurements",
    path: "/Modules/management/measurements",
    meta: indexDpnLO97KoTsvbarpn3CRQdYuv_451k5sDEUPqQAWrSOEsMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/measurements/index.vue")
  },
  {
    name: "Modules-management-workstations",
    path: "/Modules/management/workstations",
    meta: indexduRguMZWGHnKm6OayFEHpdNOOMU3FFXpvo1XMeLjMekMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/workstations/index.vue")
  },
  {
    name: "Modules-quality-control-actions",
    path: "/Modules/quality-control/actions",
    meta: index9GA9T_45qu12Mldzf1O9f4_45JnOLxhTnTMZrbQPG5ylLSgMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/actions/index.vue")
  },
  {
    name: "Modules-data-entry-inspection-ai",
    path: "/Modules/data-entry/inspection-ai",
    meta: indexIN_45KjUkUjAU_45M6Nev1HMDNzWD3vH0z7a0RfdsQNSonwMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/index.vue")
  },
  {
    name: "Modules-management-pause-reasons",
    path: "/Modules/management/pause-reasons",
    meta: indexKvqguLsqO7mdr_p0lFLyV803iBfo9tczAVWjmMAQBsoMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/pause-reasons/index.vue")
  },
  {
    name: "Modules-management-machines-types",
    path: "/Modules/management/machines-types",
    meta: index_45P5VUG1NWYtItWgjZRHvJ26Xh620nTA_454GjT5XXzaCcMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/machines-types/index.vue")
  },
  {
    name: "Modules-data-entry-inspection-rex3",
    path: "/Modules/data-entry/inspection-rex3",
    meta: indexBdy6WBzOsiGEKGjJlBpXxDymhkXUqhgNoGjFzo_45UaRsMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-rex3/index.vue")
  },
  {
    name: "Modules-quality-control-rex3-specs",
    path: "/Modules/quality-control/rex3-specs",
    meta: index7U7siVPgkkCdK1irjp9IDNkwwD_epGwubDY6fU0_454KUMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/rex3-specs/index.vue")
  },
  {
    name: "Modules-management-non-conformities",
    path: "/Modules/management/non-conformities",
    meta: index79Yh_45y_4STFf9nZUZOSMTaxXDMaPyPaDVGazMdm0y_45YMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/non-conformities/index.vue")
  },
  {
    name: "Modules-management-units-of-measure",
    path: "/Modules/management/units-of-measure",
    meta: indexLsigav4_451g2UVo7a_OhDbdmr_hv_KXM__45nRJjeHAkBkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/units-of-measure/index.vue")
  },
  {
    name: "Modules-quality-control-thicknesses",
    path: "/Modules/quality-control/thicknesses",
    meta: indexheDVOfNSPpDcF_45VHpyCDY4QRfcRhBBn1Vfdd4I5TMWwMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/thicknesses/index.vue")
  },
  {
    name: "Modules-data-entry-inspections-tree-backup",
    path: "/Modules/data-entry/inspections/tree-backup",
    meta: tree_45backupgLmPcH1tAAHqiMSAxomIM1x8V6a45Z8FyytYig8cH6cMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/tree-backup.vue")
  },
  {
    name: "Modules-management-processes-defects",
    path: "/Modules/management/processes-defects",
    meta: index_wGePMh_45OOf8bFvQxJxZDNIvPfzPinHiToCgqiwyeooMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/processes-defects/index.vue")
  },
  {
    name: "Modules-data-entry-inspection-batches",
    path: "/Modules/data-entry/inspection-batches",
    meta: indexmMqupHPuTTwm8__buU5tjA3_NPS1jYAv_45doGtNhrcioMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-batches/index.vue")
  },
  {
    name: "Modules-management-items-combinations",
    path: "/Modules/management/items-combinations",
    meta: index1ZTkPILSQ3XLQPuyzyG0CO1pc51bii5Wy9vPsIZlNR4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/items-combinations/index.vue")
  },
  {
    name: "Modules-quality-control-forms-testing",
    path: "/Modules/quality-control/forms-testing",
    meta: indexpYAtQUufJB8N0_4537JNlCXAinQecnVOmYn0dzRiZiR74Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/forms-testing/index.vue")
  },
  {
    name: "Modules-quality-control-product-specs",
    path: "/Modules/quality-control/product-specs",
    meta: index_45dfSYXSxx8iT6KnTnC8BU1910ki_XqLUFquZ6nH7ZtEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/product-specs/index.vue")
  },
  {
    name: "Modules-data-entry-inspection-ai-live-result",
    path: "/Modules/data-entry/inspection-ai/live-result",
    meta: live_45resulti_452Ha24oWjnjGDbRXzQ7wMKWSydWCEHokXz1Ro0B334Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/live-result.vue")
  },
  {
    name: "Modules-data-entry-inspection-ai-tree-backup",
    path: "/Modules/data-entry/inspection-ai/tree-backup",
    meta: tree_45backup_45q_459cBEvNNEmt431u_wY8zHUPqZwKqvnfpA0QPSKvmkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/tree-backup.vue")
  },
  {
    name: "Modules-data-entry-orders-products-orderId",
    path: "/Modules/data-entry/orders/products/:orderId()",
    meta: _91orderId_93clrgui76EPIGbDQms7lWwWVXaRrOZUd7IJ8o4FPWCG0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/products/[orderId].vue")
  },
  {
    name: "Modules-management-suppliers-materials",
    path: "/Modules/management/suppliers-materials",
    meta: indexjomO56kwnA52gkPuewwU3rLPVwujHlv79G0As10MkXoMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/suppliers-materials/index.vue")
  },
  {
    name: "Modules-quality-control-machine-limits",
    path: "/Modules/quality-control/machine-limits",
    meta: indexPva2_oGCHuKKdfiIoWMVYcs0qvQaAxAhprB_k05N4i8Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/machine-limits/index.vue")
  },
  {
    name: "Modules-data-entry-inspection-open-cell",
    path: "/Modules/data-entry/inspection-open-cell",
    meta: indexp3eV3WK8b8ph6On7jSEkdtQJjSrTdPZe7v5GtCmy_uEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-open-cell/index.vue")
  },
  {
    name: "Modules-quality-control-open-cell-specs",
    path: "/Modules/quality-control/open-cell-specs",
    meta: indexsd0CokZqOr1_ftkYrCZUCs0sQHDXNNHb9DpLqXGAIC4Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/open-cell-specs/index.vue")
  },
  {
    name: "Modules-management-workstations-products",
    path: "/Modules/management/workstations-products",
    meta: indexqYbdt9zFZe7Y0GoKgLTmJkyiWQwe8yGN3WXgVPV2fjwMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/management/workstations-products/index.vue")
  },
  {
    name: "Modules-quality-control-inspection-types",
    path: "/Modules/quality-control/inspection-types",
    meta: indexqTaDkX7gEES1jrWVIW1NSChTAMMpSXUyUAWeaIH_QPEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-types/index.vue")
  },
  {
    name: "Modules-reporting-non-conforming-products",
    path: "/Modules/reporting/non-conforming-products",
    meta: indexNSVN9b0WOWS8W5NIZYy72qu_45EY9sE9QDFnKZkzyxi_45UMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/reporting/non-conforming-products/index.vue")
  },
  {
    name: "Modules-quality-control-inspection-templates",
    path: "/Modules/quality-control/inspection-templates",
    meta: indexQbmBfQp47aL9QD_hlGqU_45aYB_45IZjMzxC7qF6n3tGYjsMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-templates/index.vue")
  },
  {
    name: "Modules-quality-control-certificates-templates",
    path: "/Modules/quality-control/certificates-templates",
    meta: indexPNkJ0WJee2ntEUTJ9vDHN8TnBqJfuYyKd802_z5i3D0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/certificates-templates/index.vue")
  },
  {
    name: "Modules-data-entry-orders-inspections-orderId",
    path: "/Modules/data-entry/orders/inspections/:orderId()",
    meta: indextbMB4o3wIGe2LNuLiYxwmVixhVFwwGgoGAdRVzD_45KbkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/inspections/[orderId]/index.vue")
  },
  {
    name: "Modules-quality-control-inspection-templates-form-id",
    path: "/Modules/quality-control/inspection-templates/form/:id()",
    meta: _91id_93R8kMRaAnUsXA8S15ctbJzcVngFrFXc_45SAdgPng6S7aYMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-templates/form/[id].vue")
  },
  {
    name: "Modules-data-entry-inspections-form-edit-inspectionId",
    path: "/Modules/data-entry/inspections/form/edit/:inspectionId()",
    meta: _91inspectionId_93LetIuiQTsAyEF8WvFGfLcb5EQGyCPJWuSN8RYq10ZVQMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/form/edit/[inspectionId].vue")
  },
  {
    name: "Modules-quality-control-inspection-templates-form",
    path: "/Modules/quality-control/inspection-templates/form",
    meta: indexXrrxOMdUiacNGRgAA1s5te7Mecher8fL_45hTpe0Eo7rkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/inspection-templates/form/index.vue")
  },
  {
    name: "Modules-quality-control-quality-inspections-sealx",
    path: "/Modules/quality-control/quality-inspections-sealx",
    meta: indexg_MpsE_45U_hlvJcX_BfJebvL5wlqJGyC0lu933X8ZB7kMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/quality-inspections-sealx/index.vue")
  },
  {
    name: "Modules-quality-control-certificates-templates-form-id",
    path: "/Modules/quality-control/certificates-templates/form/:id()",
    meta: _91id_93J36WTq_45NJFJGbq2Z51tsl8u6QCiEvsoeflDEh3u51D0Meta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/certificates-templates/form/[id].vue")
  },
  {
    name: "Modules-data-entry-inspection-ai-form-edit-inspectionId",
    path: "/Modules/data-entry/inspection-ai/form/edit/:inspectionId()",
    meta: _91inspectionId_93S_45qK7OlkDIESChzKhiUm82pLvYH8jfbTPSs5tnqdNzYMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/form/edit/[inspectionId].vue")
  },
  {
    name: "Modules-quality-control-certificates-templates-form",
    path: "/Modules/quality-control/certificates-templates/form",
    meta: indexMHNLpvtAqJHOX6w_EVR_45afvd_N_Lp_nfSp_R6b8CW1oMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/quality-control/certificates-templates/form/index.vue")
  },
  {
    name: "Modules-data-entry-inspection-rex3-form-edit-inspectionId",
    path: "/Modules/data-entry/inspection-rex3/form/edit/:inspectionId()",
    meta: _91inspectionId_937gs3vgDNjZH84bJJ6dwRjmOHy61aBlHVJ8_45BiLFZxikMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-rex3/form/edit/[inspectionId].vue")
  },
  {
    name: "Modules-data-entry-inspection-batches-form-edit-inspectionId",
    path: "/Modules/data-entry/inspection-batches/form/edit/:inspectionId()",
    meta: _91inspectionId_93ZppH_45WqSl2RJs3OJKHv5p3CQ6x_UhOXWYe84gQqPXPIMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-batches/form/edit/[inspectionId].vue")
  },
  {
    name: "Modules-data-entry-inspections-form-new-inspectionTemplateId",
    path: "/Modules/data-entry/inspections/form/new/:inspectionTemplateId()",
    meta: _91inspectionTemplateId_93cHNU7IJwqlxegdY__45440m_acuOETEeH_455orS5NtceKoMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspections/form/new/[inspectionTemplateId].vue")
  },
  {
    name: "Modules-data-entry-inspection-ai-form-new-inspectionTemplateId",
    path: "/Modules/data-entry/inspection-ai/form/new/:inspectionTemplateId()",
    meta: _91inspectionTemplateId_93thu_45cGmxZ6j9o_cU8C_p2_451pTRgudcrPI6L2ZKHOqpUMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-ai/form/new/[inspectionTemplateId].vue")
  },
  {
    name: "Modules-data-entry-inspection-open-cell-form-edit-inspectionId",
    path: "/Modules/data-entry/inspection-open-cell/form/edit/:inspectionId()",
    meta: _91inspectionId_93yJnDCzcCWOh7xF2htk8O6O_TOFFO9fCtAv_45nr8kJXMEMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/inspection-open-cell/form/edit/[inspectionId].vue")
  },
  {
    name: "Modules-data-entry-orders-inspections-orderId-form-edit-inspectionId",
    path: "/Modules/data-entry/orders/inspections/:orderId()/form/edit/:inspectionId()",
    meta: _91inspectionId_93ndalD5SrN0vE5nkfD2iTidDkUJ7XPI98wYUr1vsISBkMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/inspections/[orderId]/form/edit/[inspectionId].vue")
  },
  {
    name: "Modules-data-entry-orders-inspections-orderId-form-new-inspectionTemplateId",
    path: "/Modules/data-entry/orders/inspections/:orderId()/form/new/:inspectionTemplateId()",
    meta: _91inspectionTemplateId_933r19q0ucVf47uc962oCe2pFm4MuRPPzP2wnyiI0p2xgMeta || {},
    component: () => import("C:/temporary/iqa/iQA_FRONT/pages/Modules/data-entry/orders/inspections/[orderId]/form/new/[inspectionTemplateId].vue")
  }
]